import { render } from "./EditPartMileage.vue?vue&type=template&id=2e61d288"
import script from "./EditPartMileage.vue?vue&type=script&lang=js"
export * from "./EditPartMileage.vue?vue&type=script&lang=js"
script.render = render

export default script